// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { requestWebsiteAccessStyles } from "@guestsupply/App/Widgets/RequestWebsiteAccess/RequestWebsiteAccess";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

requestWebsiteAccessStyles.wrapper = {
    css: css`
        .stepper {
            margin-bottom: 30px;
        }
    `,
};

requestWebsiteAccessStyles.sectionTitle = {
    css: css`
        margin-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
requestWebsiteAccessStyles.accountNumberTitle = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                margin-bottom: 24px;
                border-bottom: 1px solid ${color("common.border")};
            `,
        },
        heading: {
            size: 16,
            weight: "normal",
            css: css`
                line-height: 24px;
            `,
        },
        text: {
            size: 16,
            weight: "bold",
            css: css`
                line-height: 24px;
            `,
        },
    }),
};
requestWebsiteAccessStyles.addressWrapper = {
    css: css`
        max-width: 300px;
        margin-bottom: 24px;
    `,
};
requestWebsiteAccessStyles.addressTitle = {
    wrapper: {
        css: css`
            padding-bottom: 8px;
            margin-bottom: 12px;
        `,
    },
    title: {
        as: "p",
        size: 16,
        weight: "bold",
        css: css`
            line-height: 17px;
        `,
    },
};
requestWebsiteAccessStyles.accountNumberNotify = {
    as: "p",
    css: css`
        margin-top: 16px;
        a {
            color: ${color("primary.main")};
            &:hover,
            &:focus {
                color: ${color("common.ui8")};
            }
        }
    `,
};
requestWebsiteAccessStyles.submittingAccountsNotify = {
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};
requestWebsiteAccessStyles.notifyWrapper = {
    css: css`
        margin-bottom: 16px;
    `,
};
requestWebsiteAccessStyles.toastTypography = {
    css: css`
        word-wrap: break-word;
        max-width: 325px;
    `,
};
requestWebsiteAccessStyles.accountNumberTextField = {
    cssOverrides: {
        formField: css`
            max-width: 600px;
        `,
    },
};
requestWebsiteAccessStyles.nextButton = {
    css: css`
        display: block;
        margin-top: 16px;
    `,
};
requestWebsiteAccessStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding-top: 16px;
        border-top: 1px solid ${color("common.border")};
    `,
};
requestWebsiteAccessStyles.addUserLinkWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        margin-top: 30px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
requestWebsiteAccessStyles.addAdditionalUserLink = {
    css: css`
        height: 16px;
        ${IconWrapper};
        svg {
            color: ${color("primary")};
            width: 14px;
            height: 16px;
            line-height: 17px;
            &:hover {
                opacity: 0.5;
            }
        }
    `,
};
requestWebsiteAccessStyles.addUserButton = {
    css: css`
        margin: 16px 0;
    `,
};
